<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
  >
    <g fill="none" fill-rule="evenodd">
      <g :fill="color">
        <g>
          <g>
            <path
              d="M6.5 0c.276 0 .5.224.5.5V3h8.5c.245 0 .45.177.492.41L16 3.5v10c0 1.381-1.119 2.5-2.5 2.5h-11C1.119 16 0 14.881 0 13.5V.5C0 .224.224 0 .5 0zM15 7H1v6.5c0 .731.523 1.34 1.215 1.473l.14.02L2.5 15h11c.829 0 1.5-.671 1.5-1.5V7zM6 1H1v5h14V4H6.5c-.245 0-.45-.177-.492-.41L6 3.5V1z"
              transform="translate(-24 -160) translate(0 144) translate(24 16)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'FolderIcon',
  props: {
    height: VueTypes.string.def('16'),
    width: VueTypes.string.def('16'),
    color: VueTypes.string.def('#6783B2')
  }
};
</script>

<style lang="scss"></style>
